import type {WhatsappState, FetchedWhatsappResponse} from 'src/types/whatsapp';
import type {Dispatch, ThunkAction} from 'src/reducers';
import * as reduxApiBff from 'src/utils/redux-api-bff';
import * as reduxApi from 'src/utils/redux-api-v2';
import {parseWhatsapp} from 'src/utils/whatsapp';
import type {NodeSchedule} from 'src/types/node-schedule';


export const RECEIVE_WHATSAPP_INFO = 'whatsapp/receive';
export const UPDATE_WHATSAPP_INFO = 'whatsapp/update';
export const UPDATE_NODE_SCHEDULE = 'whatsapp/update-node-schedule';
export const RESET = 'whatsapp/reset';

type UpdateWhatsappInfoPayload = Partial<WhatsappState>;

type ReceiveWhatsappInfoAction = {
  type: typeof RECEIVE_WHATSAPP_INFO;
  payload: WhatsappState;
};

type UpdateWhatsappInfoAction = {
  type: typeof UPDATE_WHATSAPP_INFO;
  payload: UpdateWhatsappInfoPayload;
};
type UpdateNodeScheduleAction = {
  type: typeof UPDATE_NODE_SCHEDULE;
  payload: Partial<NodeSchedule>;
};

type ResetStateAction = {
  type: typeof RESET;
};

export type WhatsappAction =
  | ReceiveWhatsappInfoAction
  | UpdateWhatsappInfoAction
  | UpdateNodeScheduleAction
  | ResetStateAction;

export const reset = (): ResetStateAction => ({type: RESET});

export const receiveWhatsappNode = (
  payload: WhatsappState,
): ReceiveWhatsappInfoAction => ({
  type: RECEIVE_WHATSAPP_INFO,
  payload,
});

export const updateWhatsappInfo = (
  payload: UpdateWhatsappInfoPayload,
): UpdateWhatsappInfoAction => ({
  type: UPDATE_WHATSAPP_INFO,
  payload,
});
export const updateNodeSchedule = (
  payload: Partial<NodeSchedule>,
): UpdateNodeScheduleAction => ({
  type: UPDATE_NODE_SCHEDULE,
  payload,
});
export const getWhatsappTaskNode: (node_id: string) => ThunkAction<unknown> =
  (node_id) => async (dispatch: Dispatch) => {
    try {
      const fetchedNodeResponse = await dispatch(
        reduxApiBff.get(`node/composite`, {
          node_id,
        }),
      );
      const parsedWhatsappNode: WhatsappState = parseWhatsapp(
        fetchedNodeResponse.body,
      );
      return dispatch(updateWhatsappInfo(parsedWhatsappNode));
    } catch (error: any) {
      console.error('Failed to fetch WhatsApp task node:', error);
      return null;
    }
  };

export const getSendersPhoneNumbers: (
  template_id: string,
) => ThunkAction<unknown> = (template_id) => async (dispatch: Dispatch) => {
  try {
    const url = template_id
      ? `messages/template/phones?template_id=${template_id}`
      : `messages/template/phones`;

    const fetchedResponse = await dispatch(reduxApi.get(url));
    return fetchedResponse;
  } catch (error: any) {
    console.error('Failed to fetch sender phone numbers:', error);
    return null;
  }
};
